import { Deck, DeckCard } from "@apiserver-rest/ponder-data-client-base";
import { environment } from "../../../../../environments/environment";
import { DeckGroup } from "@ponder-features/user/decks/deck/group/deck-group";

export class MagicDeckGroupCreatures extends DeckGroup {
    public constructor() {
        super("Creatures", `${environment.ponderImageBaseUrl}/magic/set/ons.svg`); // or scg
    }
    
    public override isValid(deck: Deck, card: DeckCard): boolean {
        if (card.card.item.data?.magic) {
            var frontFace = card.card.item.data.magic.faces![0];

            if (frontFace.typeLine?.includes("Creature")) {
                return true;
            }
        }

        return false;
    }
}